import {  getCaravanistsListFromLocalStorage } from "./jwt";

export const formatDateBr = (value) => value
    ? value.replace(/(\d{4})\-(\d{2})\-(\d{2})/, "$3/$2/$1")
    : value;

export const  switchGender = (value) => {
  return value;
}

export const filterNumbers = (value) => {
  return value ? value.replace(/[^\d]/g, "") : value;
}

export const formatDate = (value) => {
  return value
  ? value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
  : value;
}

export const filterGender = (value) => {
  return value;
}

export const getMobileFromForm = (participant) => {
  let mobile = participant.mobile;
  if (participant.responsible) {
    mobile = participant.responsible.mobile;
  }
  return mobile;
}

export const getEmailFromForm = (participant) => {
  let email = participant?.email;
  if (participant?.responsible?.email) {
    email = participant.responsible.email;
  }
  return email;
}

export const formatGender = (value) => {
  if (!value) return "";
  switch (value) {
    case "male":
      return "Masculino";
    case "female":
      return "Feminino";
    case "feminine":
      return "Feminino";
    default:
      return "Outros";
  }
}

export const getPhotoPreview = (isNewUser, participantData, form, preview) => {
  if (
    !isNewUser &&
    participantData &&
    participantData.photo
  ) {
    return participantData.photo;
  } else if (
    form &&
    form.photo &&
    form.photo.startsWith("data")
  ) {
    return form.photo;
  } else {
    return preview;
  }
}

export const checkIfIsVinculated = (caravanistUuid, caravanistsIdFromCpfRequest) => {

  return caravanistsIdFromCpfRequest.includes(caravanistUuid)
}

export const isVinculatedWithAnotherCaravanist = (caravanistUuid, caravanistsIdFromCpfRequest) => {

  if (caravanistsIdFromCpfRequest && caravanistsIdFromCpfRequest.length > 0) {
    // remover o uuid da caravanista atual da lista de caravanistas
    const filtered =  caravanistsIdFromCpfRequest.filter(item => item !== caravanistUuid);

    // resultado da lista de caravanista sem a caravanista atual
    // pode ser um array vazio, caso a caravanista atual seja a unica 
    if (filtered && filtered.length > 0 ) {

      // ao retirar o uuid da caravanista atual, se ainda houver item no array
      // significa que tem mais caravanistas 
      return true
    } 
  }
  return false
}